var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/environment';
import ADD_SIZE_STANDARD_SIZE_NAME from 'api/mutations/ADD_SIZE_STANDARD_SIZE_NAME';
import ADD_TENANT_SIZING from 'api/mutations/ADD_TENANT_SIZING';
import REMOVE_SIZE_STANDARD_SIZE_NAME from 'api/mutations/REMOVE_SIZE_STANDARD_SIZE_NAME';
import REMOVE_TENANT_SIZING from 'api/mutations/REMOVE_TENANT_SIZING';
import SET_DEFAULT_SIZE_STANDARD from 'api/mutations/SET_DEFAULT_SIZE_STANDARD';
import UPDATE_SIZE_STANDARD_NAME from 'api/mutations/UPDATE_SIZE_STANDARD_NAME';
import UPDATE_SIZE_STANDARD_SIZE_NAME from 'api/mutations/UPDATE_SIZE_STANDARD_SIZE_NAME';
import GET_CURRENT_TENANT_SIZINGS from 'api/queries/GET_CURRENT_TENANT_SIZINGS';
export const initialState = {
    items: [],
    pageInfo: {
        hasNextPage: true,
        endCursor: null,
    },
    status: {
        fetch: 'idle',
        add: 'idle',
        update: 'idle',
        remove: 'idle',
        setDefault: 'idle',
    },
    errors: {
        fetch: null,
        add: null,
        update: null,
        remove: null,
        setDefault: null,
    },
    refetchFlags: {
        fetch: false,
        add: false,
        update: false,
        remove: false,
    },
};
export const fetchSizes = createAsyncThunk('sizes/fetchSizes', (_, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { pageInfo } = state.parameters.sizes;
    try {
        const response = yield client.query({
            query: GET_CURRENT_TENANT_SIZINGS,
            variables: {
                first: 25,
                after: pageInfo.endCursor,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.me.currentTenant.sizeStandards.edges.map((edge) => {
            return Object.assign(Object.assign({}, edge.node), { sizes: edge.node.sizes.edges.map((edge) => edge.node) });
        });
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addSize = createAsyncThunk('sizes/addSize', ({ tenantId, name, sizeNames, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const sizeData = yield client.mutate({
            mutation: ADD_TENANT_SIZING,
            variables: { tenantId, name, sizeNames },
            fetchPolicy: 'no-cache',
        });
        return sizeData.data.addModelSpecificationSizeStandard.modelSpecificationSizeStandard;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const removeSize = createAsyncThunk('sizes/removeSize', (sizeId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: REMOVE_TENANT_SIZING,
            variables: { modelSpecificationSizeStandardId: sizeId },
        });
        return sizeId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setDefaultSizeStandard = createAsyncThunk('sizes/setDefaultSizeStandard', (modelSpecificationSizeStandardId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const sizeData = yield client.mutate({
            mutation: SET_DEFAULT_SIZE_STANDARD,
            variables: { modelSpecificationSizeStandardId },
        });
        return sizeData.data.setDefaultModelSpecificationSizeStandard.modelSpecificationSizeStandard;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateSizeStandardName = createAsyncThunk('sizes/updateSizeStandardName', ({ modelSpecificationSizeStandardId, name, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const sizeData = yield client.mutate({
            mutation: UPDATE_SIZE_STANDARD_NAME,
            variables: { modelSpecificationSizeStandardId, name },
        });
        return sizeData.data.updateSize.size;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const addSizeStandardSizeName = createAsyncThunk('sizes/addSizeStandardSizeName', ({ sizeStandardId, name }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const sizeData = yield client.mutate({
            mutation: ADD_SIZE_STANDARD_SIZE_NAME,
            variables: { sizeStandardId, name },
        });
        return (_b = (_a = sizeData.data) === null || _a === void 0 ? void 0 : _a.addModelSpecificationSizeName) === null || _b === void 0 ? void 0 : _b.modelSpecificationSizeName;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const updateSizeStandardSizeName = createAsyncThunk('sizes/updateSizeStandardSizeName', ({ modelSpecificationSizeNameId, name, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _c, _d;
    try {
        const sizeData = yield client.mutate({
            mutation: UPDATE_SIZE_STANDARD_SIZE_NAME,
            variables: { modelSpecificationSizeNameId, name },
        });
        return (_d = (_c = sizeData.data) === null || _c === void 0 ? void 0 : _c.updateModelSpecificationSizeName) === null || _d === void 0 ? void 0 : _d.modelSpecificationSizeName;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const removeSizeStandardSizeName = createAsyncThunk('sizes/removeSizeStandardSizeName', (modelSpecificationSizeNameId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const sizeData = yield client.mutate({
            mutation: REMOVE_SIZE_STANDARD_SIZE_NAME,
            variables: { modelSpecificationSizeNameId },
        });
        return sizeData.data.updateSize.size;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
const sizesSlice = createSlice({
    name: 'sizes',
    initialState,
    reducers: {
        resetSizes(state) {
            state.items = [];
            state.pageInfo = initialState.pageInfo;
            state.status = initialState.status;
            state.errors = initialState.errors;
            state.refetchFlags = initialState.refetchFlags;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSizes.pending, (state) => {
            state.status.fetch = 'loading';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchSizes.fulfilled, (state, action) => {
            var _a;
            const newSizes = action.payload;
            const uniqueSizes = newSizes.filter((newSize) => !state.items.some((existingSize) => existingSize.id === newSize.id));
            state.items = [...state.items, ...uniqueSizes];
            state.pageInfo = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.pageInfo;
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchSizes.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch = action.error.message || 'Error fetching components';
        })
            .addCase(addSize.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(addSize.fulfilled, (state, action) => {
            state.items = [
                ...state.items,
                Object.assign(Object.assign({}, action.payload), { sizes: action.payload.sizes.edges.map((edge) => edge.node), canNameBeUpdated: true, canBeRemoved: true }),
            ];
            state.status.add = 'succeeded';
        })
            .addCase(addSize.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(removeSize.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(removeSize.fulfilled, (state, action) => {
            state.items = state.items.filter((order) => order.id !== action.payload);
            state.status.remove = 'succeeded';
        })
            .addCase(removeSize.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        })
            .addCase(setDefaultSizeStandard.pending, (state) => {
            state.status.setDefault = 'loading';
            state.errors.setDefault = null;
        })
            .addCase(setDefaultSizeStandard.fulfilled, (state, action) => {
            const updatedStandard = action.payload;
            // Exactly one default per tenant - the backend clears the previous one,
            // so mirror that here instead of refetching the whole list.
            state.items = state.items.map((size) => size.id === updatedStandard.id
                ? Object.assign(Object.assign(Object.assign({}, size), updatedStandard), { isDefault: true }) : Object.assign(Object.assign({}, size), { isDefault: false }));
            state.status.setDefault = 'succeeded';
            state.errors.setDefault = null;
        })
            .addCase(setDefaultSizeStandard.rejected, (state, action) => {
            state.status.setDefault = 'failed';
            state.errors.setDefault =
                action.payload ||
                    action.error.message ||
                    'Failed to set default size standard';
        })
            .addCase(updateSizeStandardName.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(updateSizeStandardName.fulfilled, (state) => {
            state.status.remove = 'succeeded';
        })
            .addCase(updateSizeStandardName.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        })
            .addCase(addSizeStandardSizeName.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(addSizeStandardSizeName.fulfilled, (state) => {
            state.status.remove = 'succeeded';
        })
            .addCase(addSizeStandardSizeName.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        })
            .addCase(updateSizeStandardSizeName.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(updateSizeStandardSizeName.fulfilled, (state) => {
            state.status.remove = 'succeeded';
        })
            .addCase(updateSizeStandardSizeName.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        })
            .addCase(removeSizeStandardSizeName.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(removeSizeStandardSizeName.fulfilled, (state) => {
            state.status.remove = 'succeeded';
        })
            .addCase(removeSizeStandardSizeName.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.remove = action.payload;
        });
    },
});
export const { resetSizes } = sizesSlice.actions;
export const selectSizes = (state) => state.parameters.sizes.items;
export const selectSizeById = (state, sizeId) => state.parameters.sizes.items.find((size) => size.id === sizeId);
export const selectSizesPageInfo = (state) => state.parameters.sizes.pageInfo;
export const selectSizesStatus = (state) => state.parameters.sizes.status;
export const selectSizesErrors = (state) => state.parameters.sizes.errors;
export const selectSizesRefetchFlags = (state) => state.parameters.sizes.refetchFlags;
export default sizesSlice.reducer;
